import { render, staticRenderFns } from "./NuevasVacaciones.vue?vue&type=template&id=0a5a9cdc&scoped=true"
import script from "./NuevasVacaciones.vue?vue&type=script&lang=js"
export * from "./NuevasVacaciones.vue?vue&type=script&lang=js"
import style0 from "./NuevasVacaciones.vue?vue&type=style&index=0&id=0a5a9cdc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a5a9cdc",
  null
  
)

export default component.exports